import { createContext, ReactNode, useContext } from 'react'

/**
 * Provides a global boolean for whether ads should render (non-subscribers).
 */
interface AdsVisibilityContextValue {
  shouldShowAds: boolean
}

const AdsVisibilityContext = createContext<AdsVisibilityContextValue>({ shouldShowAds: true })

interface AdsVisibilityProviderProps {
  children: ReactNode
  shouldShowAds: boolean
}

export const AdsVisibilityProvider = (props: AdsVisibilityProviderProps) => {
  const { children, shouldShowAds } = props
  return <AdsVisibilityContext.Provider value={{ shouldShowAds }}>{children}</AdsVisibilityContext.Provider>
}

export const useAdsVisibility = (): AdsVisibilityContextValue => {
  return useContext(AdsVisibilityContext)
}
